import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import axiosConfig from "../../axiosConfig";
import { LoadingButton } from "@mui/lab";
import { useAppDispatch } from "../../app/hooks";
import { showSnackbar } from "../../features/snackbar/snackbarSlice";
import DeleteIcon from "@mui/icons-material/Delete";

type DeleteEmployeeProps = {
  handleFetchData: () => Promise<void>;
  detail: {
    id: string;
    username: string;
  };
};

const DeleteEmployeeButton: React.FC<DeleteEmployeeProps> = (props) => {
  const [open, setOpen] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const dispatch = useAppDispatch();

  //Handle Dialog
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //Handle Submit
  const handleSubmit = async () => {
    setLoadingButton(true);

    await axiosConfig({
      method: "delete",
      url: `/settings/delete-account/${props.detail.id}`,
    })
      .then(async (res) => {
        await props.handleFetchData();
        dispatch(
          showSnackbar({
            type: "success",
            message: "アカウントを削除しました。",
          })
        );
        setOpen(false);
      })
      .catch((err) => {
        if (err.response && err.response.status) {
          if (err.response.status === 409) {
            dispatch(
              showSnackbar({
                type: "success",
                message: `${err.response.data.body.detail}`,
              })
            );
          } else
            dispatch(
              showSnackbar({
                type: "success",
                message: `エラーが発生しました。${err.response.status}システムの管理者にお問い合わせください。`,
              })
            );
        }
      });

    setLoadingButton(false);
  };
  return (
    <div>
      <IconButton aria-label="edit" onClick={handleClickOpen}>
        <DeleteIcon fontSize="inherit" color="error" />
      </IconButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"sm"}
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">アカウント削除の確認</DialogTitle>
        <DialogContent>
          アカウント「{props.detail.username ?? ""}」を削除しますか？
          <br />
          この操作は元に戻せません。本当に削除してよろしいですか？
        </DialogContent>
        <DialogActions>
          <Button
            className="mx-4"
            onClick={handleClose}
            variant="outlined"
            sx={{ fontWeight: "bold" }}
            disabled={loadingButton}
          >
            キャンセル
          </Button>
          <LoadingButton
            onClick={handleSubmit}
            variant="contained"
            autoFocus
            sx={{ paddingX: "30px" }}
            loading={loadingButton}
          >
            確認
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default DeleteEmployeeButton;
